import { render, staticRenderFns } from "./MarketFlag.vue?vue&type=template&id=5035da17&scoped=true&"
import script from "./MarketFlag.vue?vue&type=script&lang=js&"
export * from "./MarketFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5035da17",
  null
  
)

export default component.exports